import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Icon from 'components/system/Icon';
import colors from 'styles/colors';
import UsageMetric from './UsageMetric';
import styles from './userHome.styles';

const metricStyle = {
  card: (hasBanner) => ({
    height: '38px',
    borderRadius: '8px',
    ...(!hasBanner && {
      '@media (min-height: 1020px)': {
        height: '50px',
      },
    }),
    ...(hasBanner && {
      '@media (max-height: 999px)': {},
    }),
  }),
};
const StatisticsSection = ({
  stats = {}, navigate, isLoading, hasBanner,
}) => {
  const {
    totalCount,
    totalCountCpu,
    totalCountGpu,
    totalCountQuantum,
    totalRuntime,
    totalRuntimeCpu,
    totalRuntimeGpu,
    totalRuntimeQuantum,
  } = stats;

  return (
    <Box sx={styles.stats(hasBanner)} className="statistics__container">
      <Box sx={{ ...styles.title, cursor: 'pointer' }} onClick={() => navigate('/jobs')}>
        <Typography variant="h6" color={colors.text.secondary}>
          <Icon name="atom" size={36} color={colors.text.secondary} sx={{ marginRight: '10px' }} />
          Total Jobs Run:
          <Typography variant="inherit" component="span" color={colors.text.primary}>
            {' '}
            {totalCount}
          </Typography>
        </Typography>
      </Box>
      <Grid container spacing={1}>
        <Grid item xs={4}>
          <UsageMetric
            sx={metricStyle.card(hasBanner)}
            label="GPU Jobs Run"
            value={totalCountGpu || 0}
            isLoading={isLoading}
          />
        </Grid>
        <Grid item xs={4}>
          <UsageMetric
            sx={metricStyle.card(hasBanner)}
            label="CPU Jobs Run"
            value={totalCountCpu || 0}
            isLoading={isLoading}
          />
        </Grid>
        <Grid item xs={4}>
          <UsageMetric
            sx={metricStyle.card(hasBanner)}
            label="Quantum Jobs Run"
            value={totalCountQuantum || 0}
            isLoading={isLoading}
          />
        </Grid>
      </Grid>
      <Box sx={styles.title}>
        <Typography variant="h6" color={colors.text.secondary}>
          <Icon name="timer" size={36} color={colors.text.secondary} sx={{ marginRight: '10px', width: '46px' }} />
          Total Runtime:
          <Typography variant="inherit" component="span" color={colors.text.primary}>
            {' '}
            {totalRuntime}
          </Typography>
        </Typography>
      </Box>
      <Grid container spacing={1}>
        <Grid item xs={4}>
          <UsageMetric
            sx={metricStyle.card(hasBanner)}
            label="GPU Total Runtime"
            value={totalRuntimeGpu}
            isLoading={isLoading}
          />
        </Grid>
        <Grid item xs={4}>
          <UsageMetric
            sx={metricStyle.card(hasBanner)}
            label="CPU Total Runtime"
            value={totalRuntimeCpu}
            isLoading={isLoading}
          />
        </Grid>
        <Grid item xs={4}>
          <UsageMetric
            sx={metricStyle.card(hasBanner)}
            label="Quantum Total Runtime"
            value={totalRuntimeQuantum}
            isLoading={isLoading}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default StatisticsSection;
